import { hookstate } from '@hookstate/core'

const globalRoleStore = hookstate({
});

export default globalRoleStore;